import { Col, Row } from "antd";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import {
  getDonationServiceType, DonationServiceType
} from "../../../models/donation-service/enum";
import DonationContext from "../../../context/donation-service/context";

interface IProps {}

const DonationFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(DonationContext);

  

  return (
    <Form
      formId="donation-service-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.type
              ? {
                name: "type",
                value: data.type,
                operation: "eq",
              }
              : undefined,
           
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col span={8}>
          <FieldBuilder
            name="type"
            label={`${t("type")}`}
            width="large"
            input={{
              type: "select",
              options: Object.values(DonationServiceType)
                .filter((value) => !isNaN(Number(value)))
                .map((type) => ({
                  label: t(getDonationServiceType(type as DonationServiceType)),
                  value: type as number,
                })),
            }}
          />
        </Col>
       
      </Row>
    </Form>
  );
};

export default DonationFilter;